var React = require('react');

function ExchangeAlt (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".fa-secondary{opacity:.4}")),React.createElement("path",{"d":"M128 272v48h360a24 24 0 0 1 24 24v16a24 24 0 0 1-24 24H128v48c0 21.44-25.94 32-41 17L7 369a24 24 0 0 1 0-33.94l80-80c15.14-15.12 41-4.35 41 16.94z","className":"fa-secondary","key":1}),React.createElement("path",{"d":"M505 143.05a24 24 0 0 1 0 33.95l-80 80c-15 15-41 4.49-41-17v-48H24a24 24 0 0 1-24-24v-16a24 24 0 0 1 24-24h360V80c0-21.36 25.9-32 41-17z","className":"fa-primary","key":2})]);
}

ExchangeAlt.defaultProps = {"viewBox":"0 0 512 512","className":"icon"};

module.exports = ExchangeAlt;

ExchangeAlt.default = ExchangeAlt;
